import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { ActivitiesFiltersParams } from '@core/activities-types';
import { HttpApiService } from '@core/http-legacy';

import type { TrackingActivitiesFiltersParams, TrackingActivitiesStore } from '../../types';

@Injectable({ providedIn: 'root' })
export class TrackingActivitiesHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public fetchTrackingActivities(
    payload: TrackingActivitiesFiltersParams,
  ): Observable<TrackingActivitiesStore> {
    const path = `/tracking/activities`;

    return this.trackingActivitiesFetch(path, payload.filters);
  }

  public fetchCandidateTrackingActivities(
    payload: TrackingActivitiesFiltersParams,
  ): Observable<TrackingActivitiesStore> {
    const path = `/tracking/candidates/${payload.candidateId}/activities`;

    return this.trackingActivitiesFetch(path, payload.filters);
  }

  public fetchOfferTrackingActivities(
    payload: TrackingActivitiesFiltersParams,
  ): Observable<TrackingActivitiesStore> {
    const path = `/tracking/offers/${payload.offerId}/activities`;

    return this.trackingActivitiesFetch(path, payload.filters);
  }

  public fetchTalentPoolTrackingActivities(
    payload: TrackingActivitiesFiltersParams,
  ): Observable<TrackingActivitiesStore> {
    const path = `/tracking/talent_pools/${payload.offerId}/activities`;

    return this.trackingActivitiesFetch(path, payload.filters);
  }

  public fetchRequisitionTrackingActivities(
    payload: TrackingActivitiesFiltersParams,
  ): Observable<TrackingActivitiesStore> {
    const path = `/tracking/requisitions/${payload.requisitionId}/activities`;

    return this.trackingActivitiesFetch(path, payload.filters);
  }

  private trackingActivitiesFetch(
    path: string,
    filters: ActivitiesFiltersParams | undefined,
  ): Observable<TrackingActivitiesStore> {
    return this.httpApi.get(path, { ...filters, notifications: false }).pipe(
      map(data => ({
        activities: data.activities,
        meta: data.meta,
      })),
    );
  }
}
